module.exports = __webpack_public_path__ + "img/float-m.91356ba3.jpg";